import { useParams, useLocation } from "react-router-dom";
import { supabase } from "../supabase/client";
import Header from "./Header";
import GeneralEditForm from "../pages/edit/GeneralEditForm";
import CommuteEditForm from "../pages/edit/CommuteEditForm";
import TourEditForm from "../pages/edit/TourEditForm";
import SchoolEditForm from "../pages/edit/SchoolEditForm";
import React, { useState, useEffect } from "react";

export default function DispatchForm() {
  const { id } = useParams();
  const location = useLocation();
  const reservation = location.state;

  const [data, setData] = useState(null);

  useEffect(() => {
        if (process.env.NODE_ENV !== "production") console.log("Fetching reservation with ID:", id);
    if (reservation) {
      setData(reservation);
    } else {
      const fetchReservation = async () => {
        const company = localStorage.getItem("email") || "";
        const { data, error } = await supabase
          .from("reservations")
          .select("*")
          .eq("id", id)
          .eq("company", company)
          .single();

        if (error) {
          console.error("예약 조회 실패:", error.message);
          return;
        }
        setData(data);
      };

      fetchReservation();
    }
  }, [id, reservation]);

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  if (!data) return <div>로딩 중...</div>;

  const FormComponent = {
    일반: GeneralEditForm,
    통근: CommuteEditForm,
    투어: TourEditForm,
    학단: SchoolEditForm,
  }[data.reservation_type];

  return (
    <div className="space-y-4">
    <Header />    
      <div className="p-4">
        <h2 className="text-xl font-semibold">배차대장 - {data.reservation_type}</h2>
        <FormComponent isEdit={true} defaultData={data} onChange={handleChange} />
      </div>
    </div>
  );
}
